import { Dialog } from '@progress/kendo-react-dialogs';
import { Grid, GridColumn, GridPageChangeEvent } from '@progress/kendo-react-grid';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import api from '../../../../libs/api';
import useStylesGrid from '../../../../styles/grid.styles';
import { ErrorRelaticsImportViewModel, RelaticsImportResults } from '../../../../swagger';
import LoadingPanel from '../../../../ui/old/Feedback/LoadingPanel';
import configQueryReactSimpleRequest from '../../config/configQuery';

const ErrorColumnCell = ({ data, style }: any) => {
    const errorsList = data?.errors?.map((err: ErrorRelaticsImportViewModel) => (
        <li style={{ fontSize: '12px', paddingLeft: '3%' }}>
            <b>{err.key}</b> {err.message}
        </li>
    ));

    return <td {...style}>{errorsList}</td>;
};

const useGetErrorQuery = (id: number) => {
    const fetchDataErrors = () =>
        api.get('/api/v2/AsiteRelaticsSync/GetErrorsFile', {
            safe: true,
            params: { relaticsSyncLogId: id },
        });

    const actorTypeQuery = useQuery(`relatics-sync-get-data-errors-${id}`, fetchDataErrors, {
        ...configQueryReactSimpleRequest,
    });
    return actorTypeQuery;
};
const skipItemsValue = 20;
const RelaticsDisplayErrorsDialog = ({ displayErrorsDialogActive, setdisplayErrorsDialogActive, id }: any) => {
    const classesGrid = useStylesGrid();
    const request = useGetErrorQuery(id);

    const [errorsToDisplay, setErrorsToDisplay] = useState([] as RelaticsImportResults[]);
    const [skip, setSkip] = React.useState(0);

    useEffect(() => {
        setErrorsToDisplay(request.data as RelaticsImportResults[]);
        setSkip(0);
    }, [request.data]);
    const pageChange = (event: GridPageChangeEvent) => {
        setSkip(event.page.skip);
    };
    return (
        <div>
            {request.isLoading && <LoadingPanel />}
            {displayErrorsDialogActive && request.isSuccess && (
                <Dialog
                    title={'Errors report'}
                    onClose={() => setdisplayErrorsDialogActive(!displayErrorsDialogActive)}
                    autoFocus={true}
                >
                    <Grid
                        style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}
                        data={errorsToDisplay?.slice(skip, skip + skipItemsValue)}
                        total={errorsToDisplay?.length}
                        skip={skip}
                        scrollable={errorsToDisplay?.length > skipItemsValue ? 'virtual' : 'scrollable'}
                        pageSize={skipItemsValue}
                        rowHeight={40}
                        onPageChange={pageChange}
                    >
                        <GridColumn
                            field={'asiteDocumentId'}
                            title="Asite document ID"
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'140'}
                        />
                        <GridColumn
                            field={'filePath'}
                            title="File path"
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'600'}
                        />
                        <GridColumn
                            field={'docRef'}
                            title="Document ref"
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'250'}
                        />
                        <GridColumn
                            field="errors"
                            title="Errors"
                            cell={(props) => <ErrorColumnCell {...props} data={props.dataItem} />}
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'400'}
                        />
                    </Grid>
                </Dialog>
            )}
        </div>
    );
};
export default RelaticsDisplayErrorsDialog;
